export enum ListingStatusEnum {
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    // VERIFIED = 'VERIFIED',
}
